import { select, take } from "redux-saga/effects";
import { Types } from "../../redux/cart/actions";
import { isInRouteDeskFrame } from "../../../util/helpers/deskPanelLook";
import { orderPlacedMessage, postOrderPlaced } from "../../../util/helpers/deskOrderPlaced";

// Desk build only: one "order placed" message to Route Desk for every order
// the server creates from the panel (deskOrderPlaced.js). It listens for the
// action itself, so a reload of the saved cart (order_created still true)
// never sends it twice. Does nothing on the phones.
export function* watchDeskOrderPlaced() {
  if (!isInRouteDeskFrame()) return;
  while (true) {
    const { responseData } = yield take(Types.SEND_ORDER_SUCCESS);
    const orderingFor = yield select((state) => state.cart?.ordering_for);
    const message = orderPlacedMessage(responseData, orderingFor);
    if (message) postOrderPlaced(message);
  }
}
